// var app = angular.module('MyApp', ['ngResource', 'ngMessages',
// 'ui.router','ngSanitize', 'ngAnimate', 'toastr',   'ngTable',
// 'mgcrea.ngStrap',   'satellizer' ,'angularFileUpload' ]);
var app = angular.module('MyApp', [
  'ui.router', 'ngSanitize', 'toastr', 'ngTable', 'satellizer',
  'angularFileUpload'
]);


app.run(function (
  $rootScope, $location, $auth, $http) {  // initialisation de l'application
  var absUrl = $location.absUrl();
  // alert("absUrl="+absUrl)

  $rootScope.menu = {};
  $rootScope.menu.etatPage = 1;

  $rootScope.url_ = "localhost:3010/";

  if (absUrl.indexOf('/dev/') != -1) {
    ;  // alert("bonjour christophe ___dev___");
  } else if (absUrl.indexOf('/fr/') != -1) {
    ;   //alert("bonjour fr");
  } else if (absUrl.indexOf('/en/') != -1) {
    ;  // alert("bonjour en");
  } else if (absUrl.indexOf('/es/') != -1) {
    ;
  } else if (absUrl.indexOf('/el/') != -1) {
    ;
  } else if (absUrl.indexOf('/it/') != -1) {
    ;
  } else if (absUrl.indexOf('/de/') != -1) {
    ;
  } else if (absUrl.indexOf('/pt/') != -1) {
    ;
  } else if (absUrl.indexOf('/ar/') != -1) {
    ;
  } else if (absUrl.indexOf('/pl/') != -1) {
    ;
  } else if (absUrl.indexOf('/ro/') != -1) {
    ;
  } else if (absUrl.indexOf('/ru/') != -1) {
    ;
  } else if (absUrl.indexOf('/zh/') != -1) {
    ;
  } else if (absUrl.indexOf('/hi/') != -1) {
    ;
  } else {  // autre chose !
    // alert("ni fr/dev/en...");

    var language = window.navigator.userLanguage || window.navigator.language;
    // alert(language);
    if (language == 'fr' || language == 'en' || language == 'es' ||
      language == 'el' || language == 'it' || language == 'de' ||
      language == 'pt' || language == 'ar' || language == 'pl' ||
      language == 'ro' || language == 'ru' || language == 'zh' ||
      language == 'hi') {
      $location.path('/' + language + '/');
      window.location.href = $location.url();
    } else {
      $location.path('/fr/');
      window.location.href = $location.url();
    }
  }
  //$rootScope.PORT = ":3000";

  $auth.setStorageType('localStorage');

  if (!$auth.isAuthenticated()) {  // pas connecté !
    // F5 ->
    // alert("plus connecté");
    sessionStorage.removeItem('id');
    sessionStorage.removeItem('mail');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('nom');

    $rootScope.qcmSelectionne = undefined;
    $rootScope.listeQCMlive = undefined;
    $rootScope.user = undefined;

    $rootScope.listeQCM = []

    $location.path('/');
  } else {  // encore connecté !
    // F5 -> alert("encore connecté");
    //alert("token="+localStorage.getItem("token"))
    $rootScope.user = []
    $rootScope.user.mail = localStorage.getItem('mail');
    $rootScope.user.token = localStorage.getItem('token');
    $rootScope.user.nom = localStorage.getItem('nom');
    $location.path('/0lst');
  }

  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    $rootScope.version =
      parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    alert(
      '___Utilisez un autre Navigateur : Firefox, Opera, Chrome, Edge...___');
  }

});


app.config(function (
  $stateProvider, $urlRouterProvider, $authProvider, $locationProvider,
  toastrConfig) {
  angular.extend(toastrConfig, {
    autoDismiss: true,
    containerId: 'toast-container',
    maxOpened: 0,
    timeOut: 1500,
    newestOnTop: true,
    positionClass: 'toast-bottom-right',
    preventDuplicates: false,
    preventOpenDuplicates: false,
    target: 'body'
  });

  $locationProvider.hashPrefix(
    '');  // We are actually removing ! from URLs as ! is default one.
  /**
   * Helper auth functions
   */
  var skipIfLoggedIn = function ($q, $auth) {
    var deferred = $q.defer();
    if ($auth.isAuthenticated()) {
      deferred.reject();
    } else {
      deferred.resolve();
    }
    return deferred.promise;
  };

  var loginRequired = function ($q, $location, $auth) {
    var deferred = $q.defer();
    if ($auth.isAuthenticated()) {
      deferred.resolve();
    } else {
      alert('___session expirée___');
      $location.path('/QCMscanner');
    }
    return deferred.promise;
  };

  var loginNotRequired = function ($q, $location, $auth) {
    return true;
  };

  /**
   * App routes
   */

  $stateProvider
    /*    .state('home', {
          url: '/',
          templateUrl: 'partials/qcmscan/1qcm.html',
    //      controller: 'qcmCtrl',
          resolve: {
            authenticated: function($q, $location, $auth) {
              var deferred = $q.defer();

              if (!$auth.isAuthenticated()) {
                alert("session xepirée");
                $location.path('/QCMscanner');
              } else {
                deferred.resolve();
              }
              return deferred.promise;
            }
          }
        })*/
    .state(
      'home', { url: '/', templateUrl: 'partials/qcmscan/QCMscanner.html' })
    .state('contact', {
      url: '/contact',
      templateUrl: 'partials/contact.html',
      controller: 'NavbarCtrl'
    })
    .state('faq', {
      url: '/faq',
      templateUrl: 'partials/qcmscan/faq.html',
      controller: 'NavbarCtrl'
    })
    .state('forget', {
      url: '/forget',
      templateUrl: 'partials/forget.html',
      controller: 'NavbarCtrl'
    })
    .state('logout', {
      url: '/logout',
      template: 'partials/logout.html',
      controller: 'LogoutCtrl'
    })
    .state('profile', {
      url: '/profile',
      templateUrl: 'partials/profile.html',
      controller: 'ProfileCtrl',
      resolve: { loginRequired: loginRequired }
    })
    .state('mdp', {
      url: '/mdp',
      templateUrl: 'partials/mdp.html',
      controller: 'ProfileCtrl',
      resolve: { loginRequired: loginRequired }
    })
    .state('QCMscanner', {
      url: '/QCMscanner',
      templateUrl: 'partials/qcmscan/QCMscanner.html'
      // controller: 'qcmCtrl'
    })
    .state('mention', {
      url: '/mention',
      templateUrl: 'partials/qcmscan/mention.html'
      // controller: 'qcmCtrl'
    })
    .state('0lst', {
      url: '/0lst',
      templateUrl: 'partials/qcmscan/0liste.html',
      //      controller: 'lstCtrl',
      resolve: { loginRequired: loginRequired }

    })
    .state('1qcm', {
      url: '/1qcm',
      templateUrl: 'partials/qcmscan/1qcm.html',
      //      controller: 'qcmCtrl',
      resolve: { loginRequired: loginRequired }

    })
    .state('2sol', {
      url: '/2sol',
      templateUrl: 'partials/qcmscan/2sol.html',
      //      controller: 'solCtrl',
      resolve: { loginRequired: loginRequired }
    })
    .state('3etu', {
      url: '/3etu',
      templateUrl: 'partials/qcmscan/3etu.html',
      //      controller: 'etuCtrl',
      resolve: { loginRequired: loginRequired }
    })
    .state('4upl', {
      url: '/4upl',
      templateUrl: 'partials/qcmscan/4upl.html',
      //      controller: 'uplCtrl',
      resolve: { loginRequired: loginRequired }
    })
    .state('5cop', {
      url: '/5cop',
      templateUrl: 'partials/qcmscan/5cop.html',
      resolve: { loginRequired: loginRequired }
    })
    .state('6not', {
      url: '/6not',
      templateUrl: 'partials/qcmscan/6not.html',
      resolve: { loginRequired: loginRequired }
    })
    .state('groupe', {
      url: '/groupe',
      templateUrl: 'partials/qcmscan/8groupe.html',
      resolve: { loginRequired: loginRequired }
    });

  $urlRouterProvider.otherwise('/');

  /**
   *  Satellizer config
   */
  $authProvider.facebook({ clientId: '1907025762958459' });

  $authProvider.google({
    clientId:
      '37790808977-ar2i5gdi46pm398jfsgqt119td86b07i.apps.googleusercontent.com'
  });
  //'617119659857-kchc3mb96iinlv8io8qb4agd7brvhc6j.apps.googleusercontent.com'

  $authProvider.github({ clientId: 'YOUR_GITHUB_CLIENT_ID' });

  $authProvider.linkedin({ clientId: 'YOUR_LINKEDIN_CLIENT_ID' });

  $authProvider.instagram({ clientId: 'YOUR_INSTAGRAM_CLIENT_ID' });

  $authProvider.yahoo({ clientId: 'YOUR_YAHOO_CLIENT_ID' });

  $authProvider.live({ clientId: 'YOUR_MICROSOFT_CLIENT_ID' });

  $authProvider.twitch({ clientId: 'YOUR_TWITCH_CLIENT_ID' });

  $authProvider.bitbucket({ clientId: 'YOUR_BITBUCKET_CLIENT_ID' });

  /*    $authProvider.spotify({
      clientId: 'YOUR_SPOTIFY_CLIENT_ID'
    });
  */
  $authProvider.twitter({ url: '/auth/twitter' });

  $authProvider.oauth2({
    name: 'foursquare',
    url: '/auth/foursquare',
    clientId: 'MTCEJ3NGW2PNNB31WOSBFDSAD4MTHYVAZ1UKIULXZ2CVFC2K',
    redirectUri: window.location.origin ||
      window.location.protocol + '//' + window.location.host,
    authorizationEndpoint: 'https://foursquare.com/oauth2/authenticate'
  });
});



app.factory('services', [
  '$http',
  function ($http) {
    var serviceBase = 'services/';
    var obj = {};

    // on récupère la liste des QCM
    obj.qcm = function () {
      return $http.get(serviceBase + 'qcm/');
    };

    /******************************************************************************************************/
    // on modifie un QCM
    obj.modifierQCM = function (valeur) {
      return $http.post(serviceBase + 'modifierQCM/', valeur);
    };
    // on modifie un QCMlive
    // obj.modifierQCMlive = function(valeur){
    //    return $http.post(serviceBase + 'modifierQCMlive/', valeur);
    //};
    // on efface un QCM
    obj.effaceQCM = function (valeur) {
      // alert("effacer un QCM dans le service");//+valeur.Matiere);
      return $http.post(serviceBase + 'effacerQCM', { idqcm: valeur });
    };
    // on efface un QCM
    // obj.effacerQCMlive = function(valeur){
    // alert("effacer un QCM dans le service");//+valeur.Matiere);
    //    return $http.post(serviceBase + 'effacerQCMlive', {idqcm: valeur} );
    //};
    // on ajoute un QCM
    /*    obj.ajouterQCM = function(valeur){
          //alert("ajouter un nouveau QCM dans le service");//+valeur.Matiere);
            return $http.post(serviceBase + 'ajouterQCM/', valeur);
        }
    */
    // on ajoute un QCM multipages
    obj.ajouterQCMmultipage = function (qcm, nbPage, tabPage) {
      // alert("ajouter un nouveau QCM dans le service");//+valeur.Matiere);
      return $http.post(
        serviceBase + 'ajouterQCMmultipage',
        { qcm: qcm, nbPage: nbPage, tabPage: tabPage });
    };

    obj.dupliquerQCM = function (idqcm) {
      // alert("ajouter un nouveau QCM dans le service");//+valeur.Matiere);
      return $http.post(serviceBase + 'dupliquerQCM', { idqcm: idqcm });
    };
    obj.archive = function (idqcm) {
      // alert("ajouter un nouveau QCM dans le service");//+valeur.Matiere);
      return $http.post(serviceBase + 'archive', { idqcm: idqcm });
    };


    /******************************************************************************************************/
    obj.modifMDP = function (data) {
      // alert("ajouter un nouveau QCM dans le service");//+valeur.Matiere);
      return $http.post(serviceBase + 'modifMDP', data);
    };
    obj.adduser = function (data) {
      // alert("ajouter un nouveau QCM dans le service");//+valeur.Matiere);
      return $http.post('/auth/signup', data);
    };
    /******************************************************************************************************/
    // on modifie un ETUDIANT
    // si modifié NOM ou PRENOM :
    // 1. coté serveur : changer l'étudiant sur le serveur (update)
    // 2. coté client : changer l'étudiant (tableau javascript)
    // 3. Si modifie le numéro, et que étudiant non associé à une copie
    // -> regarder si une copie non associé possède ce numéro, si oui :
    // l'associer

    obj.pdfCorrection = function (
      valeur) {  //{id:$scope.idqcm, etud:$scope.code)
      return $http.post(serviceBase + 'pdfCorrection/', valeur);
    };

    /******************************************************************************************************/
    // on ajoute un ETUDIANT
    // 1. coté serveur : changer l'étudiant sur le serveur (insert)
    // 2. coté client : changer l'étudiant (tableau javascript)
    // 3. regarder si une copie non associée possède ce numéro, si oui :
    // l'associer
    obj.effacerDoute = function (valeur) {
      return $http.post(serviceBase + 'effacerDoute/', { idcopie: valeur });
    };
    obj.ajouterETUDIANT = function (valeur, param) {
      return $http.post(
        serviceBase + 'ajouterETUDIANT/', { valeur: valeur, param: param });
    };
    obj.modifierETUDIANT = function (valeur, param) {
      // alert("modifier un ETUDIANT dans le service");//+valeur.Matiere);
      return $http.post(
        serviceBase + 'modifierETUDIANT/', { valeur: valeur, param: param });
    };
    // on efface un ETUDIANT
    obj.effacerETUDIANT = function (valeur, param) {
      // alert("effacer un ETUDIANT dans le service");//+valeur.Matiere);
      return $http.post(
        serviceBase + 'effacerETUDIANT/', { valeur: valeur, param: param });
    };
    // on efface tous les ETUDIANTS
    obj.effaceAllETUDIANTS = function (idqcm, param) {
      // alert("effacer un ETUDIANT dans le service");//+valeur.Matiere);
      return $http.post(
        serviceBase + 'effaceAllETUDIANTS/', { idqcm: idqcm, param: param });
    };

    // on récupère les étudiants DU QCM
    obj.listeEtudiant = function (idqcm) {
      if (idqcm > 0) {
        return $http.get(serviceBase + 'listeEtudiant/' + idqcm);
      }
    };
    // on récupère les étudiants DU QCM
    /*obj.listeEtudiantLive = function(idqcm){
        if (idqcm>0){ return $http.get(serviceBase +
    'listeEtudiantLive/'+idqcm); }
    };*/
    obj.gotopdfetudiant = function (a, b, c) {
      return $http.post(
        serviceBase + 'gotopdfetudiant/' + { idqcm: a, nbQ: b, nbReponse: c });
    };
    /*
    obj.archivePdf = function (idqcm) {
      return $http.get(serviceBase + 'archivePdf/' + idqcm);
    };*/
    /******************************************************************************************************/
    obj.listeGEtudiant = function (idgroupe) {
      if (idgroupe > 0) {
        return $http.get(serviceBase + 'listeGEtudiant/' + idgroupe);
      }
    };
    obj.listeGroupe = function (val) {
      return $http.get(serviceBase + 'listeGroupe/' + val);
    };
    obj.listeGroupeQCM = function (idqcm) {
      return $http.get(serviceBase + 'listeGroupeQCM/' + idqcm);
    };
    obj.newGroupe = function (valeur) {
      return $http.post(serviceBase + 'newGroupe/', { lib: valeur });
    };
    obj.renommerG = function (g) {
      return $http.post(
        serviceBase + 'renommerG/', { lib: g.lib, id: g.idGroupe });
    };
    obj.dupliquerG = function (g) {
      return $http.post(serviceBase + 'dupliquerG/', g);
    };
    obj.effaceGroupe = function (idgroupe) {
      return $http.get(serviceBase + 'effaceGroupe/' + idgroupe);
    };
    obj.ajouterGroupeQcm = function (idgroupe, idqcm) {
      return $http.post(
        serviceBase + 'ajouterGroupeQcm/',
        { idgroupe: idgroupe, idqcm: idqcm });
    };
    obj.supprimerGroupeQcm = function (idgroupe, idqcm) {
      return $http.post(
        serviceBase + 'supprimerGroupeQcm/',
        { idgroupe: idgroupe, idqcm: idqcm });
    };

    obj.remordUpdateCopie = function (idqcm, Copie) {
      console.log('debut app :  remordUpdateCopie*--*');
      a = $http.post(serviceBase + 'remordUpdateCopie/', { idqcm: idqcm, idcopie: Copie.id, resultat: Copie.resultat, remord: Copie.reponseRemord });
      //alert(serviceBase + ' et ' + JSON.stringify(a)); //alert("app - remordUpdateCopie -" + Copie.reponseRemord);
      return (1);
    };

    /******************************************************************************************************/
    // on modifie une SOLUTION
    // 1. coté serveur : changer la solution sur le serveur (update)
    // 2. coté client : changer la solution (tableau javascript)
    // 3. coté client : recalculer la note pour chaque copie
    // 4. coté client : recalculer la moyenne

    obj.modifPage =
      function (idcopie, page) {  // new
        return $http.post(
          serviceBase + 'modifPage', { idcopie: idcopie, page: page });
      }

    obj.updateSol = function (idqcm, solution) {
      return $http.post(
        serviceBase + 'updateSol', { idqcm: idqcm, solution: solution });
    };

    obj.updateNotes = function (idqcm, liste_des_notes) {
      return $http.post(
        serviceBase + 'updateNotes',
        { idqcm: idqcm, liste_des_notes: liste_des_notes });
    };

    /*
        // on change une solution...
        obj.solution = function(idqcm){
            //return $http.get(serviceBase + 'solution?idqcm='+idqcm );
            return $http.get(serviceBase + 'solution/'+idqcm );
        }
    */
    obj.solution = function (idqcm) {
      return $http.get(serviceBase + 'solution/' + idqcm);
    };

    /******************************************************************************************************/

    // on supprime les fichiers Uploadés + les copies associées
    obj.supprimerUpload = function (idqcm, fichier) {
      return $http.post(
        serviceBase + 'supprimerUpload', { idqcm: idqcm, fichier: fichier });
    };



    // on récupère les baremes DU QCM
    obj.bareme = function (idqcm) {
      if (idqcm > 0) {
        return $http.get(serviceBase + 'bareme/' + idqcm);
      }
    };


    // mofifier  les baremes DU QCM (BDD)
    obj.modifBareme = function (idqcm, indice, j, f, v, b) {
      return $http.post(
        serviceBase + 'modifBareme',
        { idqcm: idqcm, indice: indice, j: j, f: f, v: v, b: b });
    };


    // on récupère les nombrePageTab DU QCM
    obj.nombrePageTab = function (idqcm) {
      if (idqcm > 0) {
        return $http.get(serviceBase + 'nombrePageTab/' + idqcm);
      }
    };

    // on maj Remord DU QCM
    obj.majRemord = function (idqcm) {
      return $http.get(serviceBase + 'majRemord/' + idqcm);
    };
    // on récupère les copies DU QCM
    obj.listeCopie = function (idqcm) {
      return $http.get(serviceBase + 'listeCopie/' + idqcm);
    };
    // mofifier  les baremes DU QCM (BDD)
    obj.copieDoute = function (idcopie) {
      return $http.post(serviceBase + 'copieDoute', { idcopie: idcopie });
    };

    // on récupère les copies DU QCM
    obj.effacerCopie = function (idqcm, idcopie) {
      if (idcopie > 0) {
        return $http.post(
          serviceBase + 'effacerCopie', { idqcm: idqcm, idcopie: idcopie });
      }
    };

    /******************************************************************************************************/

    // on associe un étudiant à une copie
    obj.listeCopieEtudiant = function (idqcm, idcopie, idetudiant, numero) {
      return $http.put(
        serviceBase + 'copieEtudiant?idqcm=' + idqcm + '&idcopie=' + idcopie +
        '&idetudiant=' + idetudiant + '&numero=' + numero);
    };
    /******************************************************************************************************/

    // on demande la re-correction des copie avec etudiant=null...
    obj.reTraiter_les_images = function (idqcm) {
      return $http.post(serviceBase + 'reTraiter_les_images', { idqcm: idqcm });
    };

    // on demande la correction de la copie
    obj.correction = function (qcm, copie, point) {
      return $http.post(serviceBase + 'correction', {
        idqcm: qcm.id,
        UneSeuleReponse: qcm.UneSeuleReponse % 2,
        nbQuestion: qcm.nbQuestion,
        multi_nbpage: qcm.multi_nbpage,
        nbReponse: qcm.nbReponse,
        typeCoin: qcm.typeCoin,
        copie: copie,
        point: point
      });
    };

    // on demande l'inversion et la correction de la copie
    obj.inversion = function (qcm, copie) {
      return $http.post(serviceBase + 'inversion', {
        idqcm: qcm.id,
        UneSeuleReponse: qcm.UneSeuleReponse % 2,
        nbQuestion: qcm.nbQuestion,
        multi_nbpage: qcm.multi_nbpage,
        nbReponse: qcm.nbReponse,
        typeCoin: qcm.typeCoin,
        copie: copie
      });
    };


    // on demande l'envoi d'un mail
    obj.mail = function (email) {
      // alert("mail:"+email);
      return $http.post(serviceBase + 'envoyerMail', { email: email });
    };

    // on demande l'envoi d'un mail
    obj.mail_contact = function (data) {
      // alert("mail_contact")
      return $http.post(serviceBase + 'mail_contact', data);
    };

    // on demande les infos du provider
    obj.provider = function () {
      // alert("mail_contact")
      return $http.post(serviceBase + 'provider');
    };


    /******************************************************************************************************/
    return obj;
  }
]);



// COPIE DE QCM.JS -> trouver un moyen pour le mettre à un seul endroit !!
// Factory
app.service('fctService', function ($rootScope, services) {
  this.tableauSolution = function (qcm) {
    var tab = [];
    var sol = qcm.qcmSolution;
    var nb = qcm.nbQuestion;
    // var tab = [];
    // var tab = new Array;
    var c = 0;
    // alert('sol = ' + sol + "et nb=" + nb);
    var page = 1;
    var question_page = 0;
    for (var i = 0; i < nb; i++) {
      if (i < qcm.PremiereQuestionPageTab[page]) {
        question_page++;
      } else {
        question_page = 1;
        page++;
      }

      c = sol.charCodeAt(i) - 40;

      texte = '';
      if ((c & 1) !== 0)
        texte += 'A';
      else
        texte += '_';
      if ((c & 2) !== 0)
        texte += 'B';
      else
        texte += '_';
      if ((c & 4) !== 0)
        texte += 'C';
      else
        texte += '_';
      if ((c & 8) !== 0)
        texte += 'D';
      else
        texte += '_';
      if ((c & 16) !== 0)
        texte += 'E';
      else
        texte += '_';

      var res = {
        num: i,
        A: (c & 1) !== 0,
        B: (c & 2) !== 0,
        C: (c & 4) !== 0,
        D: (c & 8) !== 0,
        E: (c & 16) !== 0,
        reponse: texte,
        page: page,
        q: question_page,
        j: qcm.ptSiJuste[i],
        f: qcm.ptSiFaux[i],
        v: qcm.ptSiVide[i],
        b: (qcm.ptSiBonus[i] == 1)
      };
      tab[i] = res;
    }

    return tab;
  };



  this.majListeCopie = function () {
    if (typeof ($rootScope.qcmSelectionne) == 'undefined') {
      return;
    }
    /* FONCTION pour récupérer les copies du QCM par ajax */
    services.listeCopie($rootScope.qcmSelectionne.id).then(function (data) {
      $rootScope.listeCopie = data.data;
      if (data.data.length > 0) {
        resCopie = $rootScope.listeCopie;
        nbcopies = $rootScope.listeCopie.length;

        somme = 0;
        for (nbC = 0; (nbC < nbcopies);
          nbC++) {  // toutes les copies et pour toutes les questions !
          sommeC = 0;
          for (nbQ = 0; (nbQ < $rootScope.qcmSelectionne.nbQuestion); nbQ++) {
            c = resCopie[nbC].resultat.charAt(nbQ);
            if (c == '(') {  // pas de reponse, ça ne change rien
              // pas de reponse, ça ne change rien
              sommeC =
                sommeC + $rootScope.qcmSelectionne.ptVide;  // normalement = 0
            } else {  // tester la reponse
              if (c ==
                $rootScope.qcmSelectionne.qcmSolution.charAt(
                  nbQ)) {  // il avait faux, il a juste
                sommeC = sommeC + $rootScope.qcmSelectionne.ptJuste;

              } else {  // il avait juste, il a faux
                sommeC = sommeC + $rootScope.qcmSelectionne.ptFaux;
              }
            }
          }
          if (sommeC < 0) sommeC = 0;

          //              $rootScope.listeCopie[nbC].note20 = sommeC /
          //              ($rootScope.qcmSelectionne.nbQuestion*$rootScope.qcmSelectionne.ptJuste)*20;
          //             $rootScope.listeCopie[nbC].nbPoint = sommeC;

          somme = somme + sommeC;
        }
        $rootScope.qcmSelectionne.moyenne = somme * 20 / nbcopies / nbQ;
        $rootScope.qcmSelectionne.note = somme;
        $rootScope.qcmSelectionne.Nbcopies = nbcopies;

        $rootScope.qcmSelectionne.listeFichier = [];
        nbListeFichier = 0;
        nb = 1;
        $rootScope.qcmSelectionne.listeFichier.push({
          'nomFichierEnvoi':
            $rootScope.qcmSelectionne.listeCopie[0].fichierUpload,
          'idqcm': $rootScope.qcmSelectionne.id,
          'nb': 1
        });
        // alert('ok'+nbcopies)
        for (nbC = 1; nbC < nbcopies; nbC++) {
          trouve = false;
          for (i = 0; i < nb && !trouve; i++) {
            // alert('ok1-> '+$rootScope.listeCopie[nbC].fichierUpload)
            // alert('ok2-> '+$rootScope.listeFichier[i].nomFichierEnvoi)
            if ($rootScope.qcmSelectionne.listeFichier[i].nomFichierEnvoi ==
              $rootScope.qcmSelectionne.listeCopie[nbC].fichierUpload) {
              trouve = true;
              // alert('trouve='+trouve)
            }
          }
          if (trouve) {
            // alert('ok3-> '+$rootScope.listeFichier[i-1].nb)
            $rootScope.qcmSelectionne.listeFichier[i - 1].nb++;

          } else {
            // alert('nouveau-> '+$rootScope.listeCopie[nbC].fichierUpload)
            nb++;
            $rootScope.qcmSelectionne.listeFichier.push({
              'nomFichierEnvoi':
                $rootScope.qcmSelectionne.listeCopie[nbC].fichierUpload,
              'idqcm': $rootScope.qcmSelectionne.id,
              'nb': 1
            });
          }
        }
      } else {
        $rootScope.qcmSelectionne.moyenne = '-';
      }
    });
    return $rootScope.qcmSelectionne.listeCopie;
  };  // majListeCopie


  this.majSolution_Moyenne = function (c, caseM) {
    /* FONCTION pour MAJ la moyenne du QCM */
    if ($rootScope.qcmSelectionne.Nbcopies === 0) return '-';
    // on change le caractère dans la variable locale ($rootScope)
    var chaine = $rootScope.qcmSelectionne.qcmSolution;
    var lg = $rootScope.qcmSelectionne.qcmSolution.length;
    var nbQ = $rootScope.qcmSelectionne.qcmSolution.length;

    if (caseM === 0)
      $rootScope.qcmSelectionne.qcmSolution = c + chaine.substring(1, lg);
    else if (caseM == nbQ - 1)
      $rootScope.qcmSelectionne.qcmSolution = chaine.substring(0, lg - 1) + c;
    else if (caseM > 0)
      $rootScope.qcmSelectionne.qcmSolution =
        chaine.substring(0, caseM) + c + chaine.substring(caseM + 1, lg);

    // on parcourt toutes les copies
    // 1. pour la question "nbQ", on ajoute ou on enlève des points
    // 2. maj des notes de chaque copie dans le $rootScope.listeCopie
    // 3. recalcul de la moyenne générale
    resCopie = $rootScope.listeCopie;
    nbcopies = $rootScope.listeCopie.length;


    var somme = 0;
    var sommeC = 0;

    for (nbC = 0; (nbC < nbcopies); nbC++) {
      sommeC = 0;
      for (nbQ = 0; (nbQ < $rootScope.qcmSelectionne.nbQuestion); nbQ++) {
        c = resCopie[nbC].resultat.charAt(nbQ);
        if (c == '(') {  // pas de reponse, ça ne change rien
          // pas de reponse, ça ne change rien
        } else {  // tester la reponse
          if (c ==
            $rootScope.qcmSelectionne.qcmSolution.charAt(
              nbQ)) {  // il avait faux, il a juste
            // alert('AV-juste pour nbq='+sommeC)
            sommeC = sommeC + $rootScope.qcmSelectionne.ptJuste;
            // alert('AP-juste pour nbq='+sommeC)

          } else {  // il avait juste, il a faux
            sommeC = sommeC + $rootScope.qcmSelectionne.ptFaux;
            // alert('faux pour nbq='+nbQ)
          }
        }
      }
      sommeC = sommeC;
      if (sommeC < 0) sommeC = 0.0;

      $rootScope.listeCopie[nbC].note = sommeC /
        ($rootScope.qcmSelectionne.nbQuestion *
          $rootScope.qcmSelectionne.ptJuste) *
        20;

      somme = somme + sommeC;
    }
    somme = somme;
    $rootScope.qcmSelectionne.moyenne = somme * 20 / nbcopies /
      ($rootScope.qcmSelectionne.nbQuestion *
        $rootScope.qcmSelectionne.ptJuste);
    $rootScope.qcmSelectionne.note = somme;

    return $rootScope.qcmSelectionne.moyenne;
  };  // majMoyenne


  /****/
});
